"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _index = require("../../utils/index");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var BlogCard = props => {
  var CardAuthorInfo = props => {
    var numOfAuthors = props.item.authors.length;
    if (numOfAuthors === 0) {
      return null;
    } else if (numOfAuthors === 1) {
      var author = props.item.authors[0];
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("a", {
        href: author.url.toLowerCase()
      }, author.name), props.hideDate ? '' : /*#__PURE__*/_react.default.createElement("time", {
        className: "posted",
        dateTime: props.item.postDate
      }, props.item.postDate));
    } else {
      var authors = props.item.authors.map(function (author, index) {
        return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
          key: index
        }, index > 0 && index !== numOfAuthors - 1 && ', ', index === numOfAuthors - 1 && ' and ', /*#__PURE__*/_react.default.createElement("a", {
          key: index,
          href: author.url.toLowerCase()
        }, author.name));
      });
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, authors, props.hideDate ? '' : /*#__PURE__*/_react.default.createElement("time", {
        className: "posted",
        dateTime: props.item.postDate
      }, props.item.postDate));
    }
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "card"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "card-body"
  }, /*#__PURE__*/_react.default.createElement("section", {
    className: "mm-content-object"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "mm-media-object"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "body"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "title",
    style: {
      wordBreak: 'break-word'
    }
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: props.item.url
  }, props.item.headline)), /*#__PURE__*/_react.default.createElement("div", {
    className: "blog-author caption"
  }, /*#__PURE__*/_react.default.createElement(CardAuthorInfo, props))), /*#__PURE__*/_react.default.createElement("picture", {
    className: "mm-img-square--xl"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: (0, _index.getMMDomainUrl)(props.item.blogThumbnail),
    alt: props.item.blogThumbnailAlt
  })))), /*#__PURE__*/_react.default.createElement("div", {
    className: "card-text"
  }, props.item.overview)));
};
var _default = exports.default = BlogCard;